import { NavLink as ReactRouterLink } from 'react-router-dom';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants/shared';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';

export const $TabViewTransitionContainer = styled.div<{ $isNewUi?: boolean }>`
  position: relative;
  padding-top: ${({ $isNewUi }) => ($isNewUi ? spacing('xl') : undefined)};
`;

interface $RouteTabLinkProps {
  $isActive: boolean;
  $isHidden?: boolean;
  $count: number;
  $level: 1 | 2;
}
export const $RouteTabLink = styled(ReactRouterLink)<$RouteTabLinkProps>`
  @media ${media.maxWidth.xs} {
    &&& {
      ${fontStyle('base')};
    }
  }

  text-decoration: none;

  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  color: ${({ theme, $isActive }) => {
    if ($isActive) {
      return theme.colors.primary;
    }

    return theme.colors.mainTextColor;
  }};
  ${({ $level }) => ($level === 1 ? fontStyle('lg') : fontStyle('base'))};
  font-weight: ${({ $isActive }) =>
    $isActive ? fontWeight('bold') : fontWeight('normal')};
  position: relative;
  cursor: pointer;
  padding-bottom: ${spacing('lg')};

  &:hover {
    outline: 0;
    color: ${({ theme }) => theme.newUI.variationColors.light1};
    text-decoration: unset;
  }

  &:hover svg {
    color: ${({ theme }) => theme.newUI.variationColors.light1};
  }

  border-bottom: ${({ $isActive, theme }) =>
    $isActive ? `2px solid ${theme.colors.primary}` : '2px solid transparent'};
`;

interface $MessageWithIconProps {
  $isActive?: boolean;
}

export const $MessageWithIcon = styled.div<$MessageWithIconProps>`
  align-items: center;
  display: flex;
  ${fontStyle('sm')};

  svg {
    width: ${spacing(5)};
    height: ${spacing(7)};
    margin-right: ${spacing(1.5)};
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.primary : theme.colors.paragraphTextColor};
  }

  &:hover,
  &:focus {
    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const $RouteTabSize = styled.div`
  display: flex;
`;

export const $Counter = styled.div`
  margin-left: ${spacing('sm')};
  border-radius: ${({ theme }) => theme.newUI.borders.smallRadius};
  background-color: ${({ theme }) => theme.newUI.tagsColors?.primary.bgColor};
  color: ${({ theme }) => theme.newUI.tagsColors?.primary.color};
  align-self: center;
  margin-bottom: ${spacing('lg')};
  padding: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  width: ${spacing(5)};
  height: ${spacing(5)};
  ${fontStyle('xxs')};
  font-weight: ${fontWeight('bold')};
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
